import {
  Navigate,
  createRootRoute,
  createRoute,
  createRouter,
  type RouterHistory
} from '@tanstack/react-router'
import {
  ResumePage,
  SignatureReturnPage,
  SponsoredEnrollmentPage
} from '@/features/enrollment'
import { ErrorPage, RootLayout } from '@/shared/components'
import {
  DEFAULT_ENROLLMENT_PATH,
  enrollmentPaths,
  enrollmentRoutePrefixes
} from './paths'

const RootErrorBoundary = () => (
  <ErrorPage
    code="500"
    title="Something Went Wrong"
    message="We're sorry, but something unexpected happened. Please try refreshing the page."
    showHome
    showRefresh
  />
)

const rootRoute = createRootRoute({
  component: RootLayout,
  errorComponent: RootErrorBoundary,
  notFoundComponent: () => <Navigate to={DEFAULT_ENROLLMENT_PATH as never} replace />
})

const sponsoredEnrollRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: enrollmentPaths.sponsoredEnroll,
  component: SponsoredEnrollmentPage
})

const resumeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: enrollmentPaths.resume,
  component: ResumePage
})

const signatureReturnRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: enrollmentPaths.signatureReturn,
  component: SignatureReturnPage
})

const routeTree = rootRoute.addChildren([
  sponsoredEnrollRoute,
  signatureReturnRoute,
  resumeRoute
])

export { enrollmentRoutePrefixes }
export { DEFAULT_ENROLLMENT_PATH }

export const createEnrollmentRouter = (history?: RouterHistory) =>
  createRouter({
    routeTree,
    history
  })

export const router = createEnrollmentRouter()

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
